import {createContext} from 'react';

const ContactContext = createContext(null);

export default ContactContext;
